import translate from '@translate';
import React, { FC } from 'react';
import Select from 'src/components/Select';
import { OrderType } from 'src/types/order';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Tooltip from 'src/components/Tooltip';
import Menu from 'src/components/Menu';
import { OnChangeType } from 'src/components/Select';
import { DolarIcon } from '../SkladonIcon/SmallIcons';
import { sizes } from 'src/themes/default';

export interface PaidActionOptionType {
    label: string;
    STATUS: string;
    PAYMENT_METHOD: string;
    PAID: number;
}

export const paidActionOptions: PaidActionOptionType[] = [
    {
        label: 'transferPaymentPaid',
        STATUS: 'waitingForShipment',
        PAYMENT_METHOD: '2',
        PAID: 1,
    },
    {
        label: 'transferPaymentNotPaid',
        STATUS: 'waitingForPayment',
        PAYMENT_METHOD: '2',
        PAID: 0,
    },
    {
        label: 'cashOnDelivery',
        STATUS: 'waitingForShipment',
        PAYMENT_METHOD: '0',
        PAID: 0,
    },
    {
        label: 'onlinePaymentPaid',
        STATUS: 'waitingForShipment',
        PAYMENT_METHOD: '1',
        PAID: 1,
    },
    {
        label: 'onlinePaymentNotPaid',
        STATUS: 'waitingForPayment',
        PAYMENT_METHOD: '1',
        PAID: 0,
    },
    {
        label: 'transferPaymentSend',
        STATUS: 'waitingForShipment',
        PAYMENT_METHOD: '2',
        PAID: 1,
    },
];

export interface PaymentEditPropsType {
    onChange: OnChangeType;
    disabled: boolean;
    error: boolean;
    disablePaidActions: boolean;
    paymentCodes: ConstantsCodeType[];
    handlePaidAction: (paidOption: PaidActionOptionType) => void;
    value: any;
}

const PaymentEdit: FC<PaymentEditPropsType> = (props) => {
    return (
        <>
            <Select
                options={props.paymentCodes}
                value={props.value}
                error={props.error}
                onChange={props.onChange}
                name="PAYMENT_METHOD"
                label={translate('paymentEdit.paymentMethod')}
                fullWidth
                required
                disabled={props.disabled}
                sx={{ width: 'calc(100% - 46px)' }}
            />
            {!props.disablePaidActions && (
                <Menu
                    variant="menu"
                    className="payment-menu"
                    inline
                    icon={
                        <Tooltip title={translate('paymentEdit.paidOrderOptions')}>
                            <div style={{ height: '34px' }}>
                                <DolarIcon />
                            </div>
                        </Tooltip>
                    }
                    iconSx={{
                        margin: sizes.icon_button_next_to_input_MG,
                        '& svg': {
                            width: sizes.icon_button_next_to_input_svg_size,
                            height: sizes.icon_button_next_to_input_svg_size,
                        },
                    }}
                    items={paidActionOptions.map((option) => (
                        <div
                            key={option.label}
                            onClick={() => props.handlePaidAction(option)}
                            style={{ width: '100%' }}
                        >
                            {translate(`paymentEdit.paidAction.${option.label}`)}
                        </div>
                    ))}
                />
            )}
        </>
    );
};

export default PaymentEdit;
